import type { GetMarketRow } from '@morfi/backend-sdk-v2/client';
import { useState } from 'react';

/** The controller advances on authoritative changes; live leaves own conviction ticks. */
export function useChartMarketSnapshot(market) {
  const [snapshot, setSnapshot] = useState(market);
  if (sameMarketSnapshot(snapshot, market)) {
    return snapshot;
  }
  setSnapshot(market);
  return market;
}
function sameMarketSnapshot(previous: GetMarketRow | undefined, next: GetMarketRow | undefined): boolean {
  if (previous === next) return true;
  if (previous === undefined || next === undefined) return false;
  if ((Object.keys(next) as (keyof GetMarketRow)[]).some(key => key !== 'outcomes' && next[key] !== previous[key])) return false;
  if (previous.outcomes.length !== next.outcomes.length) return false;
  return next.outcomes.every((outcome, index) => {
    const old = previous.outcomes[index];
    return old !== undefined && (Object.keys(outcome) as (keyof typeof outcome)[]).every(key => key === 'conviction' || outcome[key] === old[key]);
  });
}